function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.049,71.4H39.97a.7.7,0,1,1,0-1.4h2.079a.7.7,0,0,1,0,1.4Z",
  transform: "translate(-10.608 -19.4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.857,52h-13.4a.714.714,0,1,1,0-1.429h13.4a.714.714,0,0,0,.714-.714V4.143a.714.714,0,0,0-.714-.714H4.143a.714.714,0,0,0-.714.714V49.857a.714.714,0,0,0,.714.714H17.264a.714.714,0,1,1,0,1.429H4.143A2.143,2.143,0,0,1,2,49.857V4.143A2.143,2.143,0,0,1,4.143,2H49.857A2.143,2.143,0,0,1,52,4.143V49.857A2.143,2.143,0,0,1,49.857,52Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.1,71.4H30.07a.7.7,0,1,1,0-1.4H32.1a.7.7,0,1,1,0,1.4Z",
  transform: "translate(-7.791 -19.4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.286,19.4H2.714a.7.7,0,1,1,0-1.4H51.286a.7.7,0,1,1,0,1.4Z",
  transform: "translate(0 -4.565)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.867,11.712h-.778a.7.7,0,0,1,0-1.4h.778a.7.7,0,0,1,0,1.4Z",
  transform: "translate(-16.817 -2.494)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.5,11.712h-.778a.7.7,0,1,1,0-1.4H55.5a.7.7,0,1,1,0,1.4Z",
  transform: "translate(-14.83 -2.494)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.14,11.712h-.778a.7.7,0,1,1,0-1.4h.778a.7.7,0,1,1,0,1.4Z",
  transform: "translate(-12.731 -2.494)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.235,11.712H10.2a.7.7,0,0,1,0-1.4H31.235a.7.7,0,1,1,0,1.4Z",
  transform: "translate(-2.25 -2.494)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.325,32.15h-5.25a.7.7,0,0,1-.7-.7V26.2a.7.7,0,0,1,.7-.7h5.25a.7.7,0,0,1,.7.7v5.25A.7.7,0,0,1,17.325,32.15Zm-4.55-1.4h3.85V26.9h-3.85Z",
  transform: "translate(-2.813 -6.662)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.325,45.9h-5.25a.7.7,0,0,1-.7-.7V39.95a.7.7,0,0,1,.7-.7h5.25a.7.7,0,0,1,.7.7V45.2A.7.7,0,0,1,17.325,45.9Zm-4.55-1.4h3.85V40.65h-3.85Z",
  transform: "translate(-2.813 -10.559)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.325,59.65h-5.25a.7.7,0,0,1-.7-.7V53.7a.7.7,0,0,1,.7-.7h5.25a.7.7,0,0,1,.7.7v5.25A.7.7,0,0,1,17.325,59.65Zm-4.55-1.4h3.85V54.4h-3.85Z",
  transform: "translate(-2.813 -14.3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.725,30.65h-22.4a.7.7,0,0,1,0-1.4h22.4a.7.7,0,0,1,0,1.4Z",
  transform: "translate(-6.987 -7.774)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.725,44.4h-22.4a.7.7,0,0,1,0-1.4h22.4a.7.7,0,0,1,0,1.4Z",
  transform: "translate(-6.987 -11.697)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.725,58.15h-22.4a.7.7,0,0,1,0-1.4h22.4a.7.7,0,0,1,0,1.4Z",
  transform: "translate(-6.987 -15.62)"
}));

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.31c4849c.svg";
export { ForwardRef as ReactComponent };